// src/pages/Proposta/PropostaDetalhesPage.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import PropostaDetails from '../../components/Proposta/PropostaDetails';
import { Box, Typography, Container } from '@mui/material';

const PropostaDetalhesPage = () => {
  const { id } = useParams(); // Pega o ID da URL

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
          Detalhes da Proposta
        </Typography>
        
        <PropostaDetails propostaId={id} />
      </Box>
    </Container>
  );
};

export default PropostaDetalhesPage;